$(function(){
	/**
	 * Created with JetBrains PhpStorm.
	 * User: Unkn0wn
	 * Date: 13.10.13
	 * Time: 20:08
	 */

    $("#password-editor-container").magnificPopup({
		type:'inline',
		preloader: false,
		modal: false,
		items: [
			{
				src: '#password-editor-container-content'
			}
		],
		callbacks: {
			open: function() {
				var dlg = this.content;

                $('#password-edit').off().on("submit", function(e) {
                    $(this).ajaxSubmit({
                        success: function(result) {
                            alertify.success("Updated success",3000);
                            $( dlg ).magnificPopup( "close" );
                        },
                        error: function(xhr){
                            console.log("error detected");
                            $( dlg ).magnificPopup( "close" );
                            alertify.error(getServerErrorString(xhr, true), 5000);
                        },
                        dataType: 'json'

                    });

                    e.preventDefault();
                });

				$('.btnCancel, .mfp-close',dlg).click(function(){
					$(dlg).magnificPopup('close');

					return false;
				});
			}
		}
	});


	$('#change-password').click(function(){
		$( "#password-editor-container" ).magnificPopup( "open" );

		return false;
	});
});
